import { TableCell, Typography } from "@mui/material"
import { formatDate } from "utils/HelperFunctions"

function MessagesTableRows({ message }) {
  return (
    <>
      <TableCell align="left">
        <Typography variant='body'>{formatDate(message.created)}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{`${message.sender.firstName} ${message.sender.lastName}`}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{message.title || '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{message.message || '-'}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant='body'>{message.visited ? 'Si' : 'No'}</Typography>
      </TableCell>
    </>
  )
}

export default MessagesTableRows